// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BBfd","field":"styles_field__3xlko","fieldCol":"styles_fieldCol__hhybj","diffCol":"styles_diffCol__1KNWG","diff":"styles_diff__37IC7"};